import { holterFollowUpConsultRequestSections } from '@common/validation/customControls/cardiology/holter/holterFollowUpConsultRequestSchemas';
import { getPsDataInputComponents } from '@frontend/components/pages/customControls/utils/v1/labResults/getPsDataInputComponents';
import { EditForm } from '@frontend/formEngine/editForm/EditForm';
import { HolterConsultationFollowingSteps } from '../customComponents/HolterConsultationFollowingSteps';
import { getRecipientDataInputComponents } from '../utils/getRecipientDataInputComponents';

export function HolterFollowUpConsultRequestEdit(): JSX.Element {
    const inputComponents = new Map([...getPsDataInputComponents(), ...getRecipientDataInputComponents()]);

    return (
        <>
            <EditForm
                inputComponents={inputComponents}
                sections={holterFollowUpConsultRequestSections}
            />

            <HolterConsultationFollowingSteps />
        </>
    );
}
